import React from 'react';
import RemoteImageSplashDetailNavbar from '../RemoteImageSplashDetailNavbar';
import RemoteImageSplashDetailInfo from '../RemoteImageSplashDetailInfo';

const RemoteImageSplashDetailWrap = (props) => {
  const { detailPageType, onSubmit, remoteImageSplashDetail, setData, copyUrl } = props;

  return (
    <div className="remote-image-detail-wrap">
      {/* 하단 네브바 */}
      <RemoteImageSplashDetailNavbar
        detailPageType={detailPageType}
        remoteImageSplashDetail={remoteImageSplashDetail}
        onSubmit={onSubmit}
      />

      {/* 원격 이미지 정보 */}
      <RemoteImageSplashDetailInfo
        detailPageType={detailPageType}
        remoteImageSplashDetail={remoteImageSplashDetail}
        setData={setData}
        copyUrl={copyUrl}
      />
    </div>
  );
};

export default RemoteImageSplashDetailWrap;
